// Super Admin Organization Endpoints
export const SA_ORG_REGISTRATION = "/authentication/sa-org-registration";
export const SA_ORGANIZATIONS_LIST = "/authentication/super-admin/organizations";
export const SA_ORGANIZATIONS_EXPORT = "/super-admin/organizations/export";
export const SA_ORG_PROFILE = (orgId: string) => `/sa-organizations/${orgId}`;
export const SA_ORG_UPDATE = (orgId: string) => `/authentication/sa-organizations/${orgId}/update`;
export const SA_ORG_DEACTIVATE = (orgId: string) => `/sa-organizations/${orgId}/deactivate`;

// Super Admin User Endpoints
export const SA_USER_PROFILE = "/authentication/sa-user-profile";
export const SA_USER_SIGNOUT = "/secure-auth/logout";

// Authentication Endpoints
export const LOGIN_ENDPOINT = "/secure-auth/login"; 
export const RESEND_PASSWORD="authentication/forgot-password ";
export const RESET="/authentication/reset-password";